import { useQuery } from "@tanstack/react-query";
import { useProject } from "../project";
import { computeProjectProgress } from "../project-progress";
import { useProjectTasksQuery } from "./project-tasks";

export function useProjectProgressQuery() {
    const { project } = useProject();
    const tasksQuery = useProjectTasksQuery();
    return useQuery({
        queryKey: ["project", project.id, "progress"],
        queryFn: () => {
            const tasks = tasksQuery.data!.data;
            return computeProjectProgress({ tasks });
        },
        enabled: !!tasksQuery.data,
    });
}
